import React, { useEffect } from "react";
import InnerHeader from "component/shared/innerheader/InnerHeader";
import { useIntl } from "react-intl";
import { Link } from "react-router-dom";
import ChevronIcon from "svg-icons/chevron-icon";
import './index.scss'
import { END_POINTS } from "constants/APIConstant";
import ReactGA from "react-ga4";

function Sitemap() {
  const intl = useIntl();

  React.useEffect(() => {
    const timeOut = setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);
    return () => {
      clearTimeout(timeOut)
    }
  }, [])
  

  ReactGA.initialize(END_POINTS.TRACKING_ID)

  useEffect(() => {
    // Send pageview with a custom path
    ReactGA.send({ hitType: "pageview", page: "/sitemap", title: "Sitemap Page" });
  }, []);


  const sitemap = [
    {
        id: '1',
        title: intl.formatMessage({ id: "home" }),
        link: '../home',
        children: [
            {
                id: '11',
                title: intl.formatMessage({ id: "related-websites" }),
                link: '../related',
                internal: true
            }
        ]
    },
    {
        id: '2',
        title: intl.formatMessage({ id: "the-new" }),
        link: '../new',
        children: []
    },
    {
        id: '3',
        title: intl.formatMessage({ id: "data" }),
        link: '../data',
        children: [
            {
                id: '31',
                title: intl.formatMessage({ id: "external-trade-sitemap" }),
                link: '../external-trade',
                internal: true
            },
            {
                id: '32',
                title: intl.formatMessage({ id: "browse-data-visualization" }),
                link: '../data/mainSubject/1/subSubject/1/data-visualization/0',
                internal: true
            }
        ]
    },
    {
        id: '4',
        title: intl.formatMessage({ id: "publications" }),
        link: '../publications',
        children: [
            {
                id: '41',
                title: intl.formatMessage({ id: "statistical-bulletins" }),
                link: '../publications/1',
                internal: true
            }
        ]
    },
    {
        id: '5',
        title: intl.formatMessage({ id: "service-tools" }),
        link: '../servicestools',
        children: [
            {
                id: '51',
                title: intl.formatMessage({ id: "metadata" }),
                link: null,
                internal: false
            },
            {
                id: '52',
                title: intl.formatMessage({ id: "raw-data-eligible-for-use" }),
                link: null,
                internal: true
            },
            {
                id: '53',
                title: intl.formatMessage({ id: "calender-sitemap" }),
                link: '../calender',
                internal: true
            },
            {
                id: '54',
                title: intl.formatMessage({ id: "register-website-sitemap" }),
                link: '../register',
                internal: true
            },
            {
                id: '55',
                title: intl.formatMessage({ id: "publication-prices" }),
                link: '../prices',
                internal: true
            },
            {
                id: '56',
                title: intl.formatMessage({ id: "newsletters" }),
                link: null,
                internal: false
            },
            {
                id: '57',
                title: intl.formatMessage({ id: "agree-request" }),
                link: null,
                internal: false
            },
            {
                id: '58',
                title: intl.formatMessage({ id: "data-request" }),
                link: '../datarequest',
                internal: true
            },
            {
                id: '59',
                title: intl.formatMessage({ id: "microfilm-sitemap" }),
                link: '../microfilm',
                internal: true
            },
            {
                id: '500',
                title: intl.formatMessage({ id: "training-centers" }),
                link: '../nationalCenter',
                internal: true
            },
        ]
    },
    {
        id: '6',
        title: intl.formatMessage({ id: "media-center" }),
        link: '../mediaLanding',
        children: [
            {
                id: '61',
                title: intl.formatMessage({ id: "news" }),
                link: '../mediaLanding/news',
                internal: true
            },
            {
                id: '62',
                title: intl.formatMessage({ id: "images-videos" }),
                link: '../mediaLanding/media',
                internal: true
            },
            {
                id: '63',
                title: intl.formatMessage({ id: "egyptian-statistical-review" }),
                link: '../mediaLanding/magazine',
                internal: true
            }
        ]
    },
    {
        id: '7',
        title: intl.formatMessage({ id: "about" }),
        link: '../about',
        children: [
            {
                id: '71',
                title: intl.formatMessage({ id: "vision-mission" }),
                link: '../about/vision-mission',
                internal: true
            },
            {
                id: '72',
                title: intl.formatMessage({ id: "chairman-word" }),
                link: '../about/chairman-word',
                internal: true
            },
            {
                id: '73',
                title: intl.formatMessage({ id: "organizaitional-structure" }),
                link: '../about/organizaitional-structure',
                internal: true
            },
            {
                id: '74',
                title: intl.formatMessage({ id: "device-history" }),
                link: '../about/device-history',
                internal: true
            },
            {
                id: '75',
                title: intl.formatMessage({ id: "laws-frameworks" }),
                link: '../about/laws-frameworks',
                internal: true
            }
        ]
    },
    {
        id: '8',
        title: intl.formatMessage({ id: "contact-us" }),
        link: '../contact',
        children: []
    },
  ]

  const renderSiteMapFirst = () => {
    const rendering =
      Object.keys(sitemap).length > 0 ? (
        <>
          {sitemap.slice(0,5).map(
            ({ id, title, link, children }) => (
                <div key={id} className="item">
                    <ChevronIcon width={10} height={10} />
                    <Link to={link}>{title}</Link>
                    <ul>
                        {children.map(child => (
                            <li key={child.id}>
                                <ChevronIcon width={10} height={10} />
                                {child.link ?
                                    <Link to={child.link}>{child.title}</Link>
                                    :
                                    <span>{child.title}</span>
                                }
                            </li>
                        ))}
                    </ul>
                </div>
            )
          )}
        </>
      ) : (
        <DataNotFound />
      );
    return rendering;
  };

  const renderSiteMapSecond = () => {
    const rendering =
      Object.keys(sitemap).length > 0 ? (
        <>
          {sitemap.slice(5,10).map(
            ({ id, title, link, children }) => (
                <div key={id} className="item">
                    <ChevronIcon width={10} height={10} />
                    <Link to={link}>{title}</Link>
                    <ul>
                        {children.map(child => (
                            <li key={child.id}>
                                <ChevronIcon width={10} height={10} />
                                {child.link ?
                                    <Link to={child.link}>{child.title}</Link>
                                    :
                                    <span>{child.title}</span>
                                }
                            </li>
                        ))}
                    </ul>
                </div>
            )
          )}
        </>
      ) : (
        <DataNotFound />
      );
    return rendering;
  };

  return (
    <div className="sitemap pb-4">
        <InnerHeader
            breadcrumb={[
            { title: intl.formatMessage({ id: "sitemap" }), clickClass: true },
            ]}
            title={intl.formatMessage({ id: "sitemap" })}
        />
        <div className="container mt-5">
            <div className="row d-flex justify-content-center">
                <div className="col-lg-6">
                    {renderSiteMapFirst()}
                </div>
                <div className="col-lg-6">
                    {renderSiteMapSecond()}
                </div>
            </div>
        </div>
    </div>
  );
}

export default Sitemap;
